export default __webpack_public_path__ + "static/media/loginBiowood.f18259b3.png";